import React from 'react'
import { connect } from 'react-redux'
import { AuditDetail, EntityType } from 'api'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import Ticket from 'view/routes/requests/rfqTicket'
import { Locale, Translation } from 'locale'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { getRFQTitle } from 'view/routes/requests/shared/utils'
import { WindowActions } from 'epics/windowEpic'
import { isOpenFin } from 'utils'
import { ActionsButtonProps } from 'view/components/datagrid'

export interface AuditActionsButtonProps extends ModalConsumerProps, ActionsButtonProps<AuditDetail> {
  disabled?: boolean
  onOpenTicket: (entityId: string, entityType: EntityType, windowTitle: string, ownOrder: boolean, history: boolean) => unknown
}

const mapDispatchToProps = {
  onOpenTicket: WindowActions.openTicketWindow
}

export class AuditActionsButtonComponent extends React.Component<AuditActionsButtonProps> {
  render() {
    const actions: ActionItem[] = [
      {
        label: this.getLabel(Translation.TC_ACTION_OPEN_TICKET),
        onClick: this.handleOpenTicket,
        enabled: true
      }
    ]

    return <SplitButtonDropdown actions={actions} disabled={this.props.disabled} maxButtons={1} />
  }

  private getLabel = (baseLabel: Translation) => {
    const { items, isGroupRow } = this.props
    const count = isGroupRow ? ` (${items.length})` : ``
    return `${Locale.translate(baseLabel)}${count}`
  }

  private handleOpenTicket = () => {
    const { onOpenTicket, showModal, items } = this.props
    items.forEach(auditDetail => {
      if (isOpenFin()) {
        onOpenTicket(auditDetail.negotiation.negotiationId, EntityType.NEGOTIATION, getRFQTitle(auditDetail), auditDetail.ownOrder, true)
      } else {
        showModal(<Ticket negotiationId={auditDetail.negotiation.negotiationId} ownOrder={auditDetail.ownOrder} history={true} />)
      }
    })
  }
}

export const AuditActionsButton = withModal(connect(null, mapDispatchToProps)(AuditActionsButtonComponent))
